import { axiosGateway } from '@/services/axiosTools'

// 游戏搜索
export function gameSearch(params) {
    return axiosGateway.get(
        {
            url: `cloud-pcmgr-deskframe/rest/applet/game/v1/search`,
            gatewayKey: 'baseURL3',
            params
        })
}